export default __webpack_public_path__ + "static/media/trussardi.3bad183c.png";